import { ConsentOrdersPathName } from "@fla/components";
import { selectConsentOrdersBase } from "pages/ConsentOrders/consentOrdersSelectors";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export const withConsentOrder = (Component: FC) => {
  const WithConsentOrderWrapper = () => {
    const { pathname } = useLocation();
    const co = useSelector(selectConsentOrdersBase);

    const { initialDetails, submitted } = co;

    const isInitialDetailsCompleted = initialDetails?.isCompleted;

    const restrictPaths = [
      ConsentOrdersPathName.RealEstate,
      ConsentOrdersPathName.Superannuation,
      ConsentOrdersPathName.Bank,
      ConsentOrdersPathName.Business,
      ConsentOrdersPathName.Vehicle,
      ConsentOrdersPathName.Investments,
      ConsentOrdersPathName.Overseas,
      ConsentOrdersPathName.Furniture,
      ConsentOrdersPathName.Debts,
      ConsentOrdersPathName.AdditionalRequirements,
      ConsentOrdersPathName.Summary,
      ConsentOrdersPathName.Submit
    ];

    if (restrictPaths.includes(pathname as ConsentOrdersPathName) && !isInitialDetailsCompleted) {
      return <Navigate to={ConsentOrdersPathName.InitialDetails} />;
    }
    if (
      [...restrictPaths, ConsentOrdersPathName.InitialDetails].includes(pathname as ConsentOrdersPathName) &&
      submitted === true
    ) {
      return <Navigate to="/" />;
    }
    return <Component />;
  };
  return WithConsentOrderWrapper;
};
